import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import { Box, FormControl, IconButton, Stack, Typography } from "@mui/material"
import { useGetServiceAccountsQuery } from "../../services/serviceAccountsApi"
import { useAppSelector } from "../../store/hooks"
import {
  selectActiveOrg,
  selectUserIsOrgServiceAdmin,
} from "../../store/sessionSlice"
import { ServiceAccountsSection } from "./ServiceAccountsSection"
import { getErrorMessage } from "./utils"

export function OrgSettingsPage() {
  const activeOrg = useAppSelector(selectActiveOrg)
  const activeOrgId = activeOrg.id
  const isOrgServiceAdmin = useAppSelector(selectUserIsOrgServiceAdmin)
  const {
    currentData: serviceAccountsResponse,
    error: loadError,
    isLoading,
  } = useGetServiceAccountsQuery(
    { org_id: activeOrgId },
    {
      skip: !activeOrgId,
    }
  )
  const serviceAccounts = serviceAccountsResponse?.data ?? []
  const loadErrorMessage = getErrorMessage(loadError)

  return (
    <Stack spacing={3}>
      <Typography variant="h1">Organization Settings</Typography>

      <FormControl>
        <Typography variant="overline">Organization ID</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box component="code">{activeOrgId}</Box>
          <IconButton
            aria-label="Copy organization ID"
            onClick={() => {
              navigator.clipboard.writeText(activeOrgId)
            }}
            disabled={!activeOrgId}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Box>
      </FormControl>

      <ServiceAccountsSection
        activeOrgId={activeOrgId}
        activeOrgName={activeOrg.name}
        isOrgServiceAdmin={isOrgServiceAdmin}
        isLoading={isLoading}
        loadErrorMessage={loadErrorMessage}
        serviceAccounts={serviceAccounts}
      />
    </Stack>
  )
}
